export default function Forbidden() {
  return <>403 page</>;
}
